module.exports = __webpack_public_path__ + "static/img/package_3.cfac195.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/package_3.jpg
// module id = ogCb
// module chunks = 1